import React from 'react';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import BindEnterAndSpaceToClick from '../../../core/Utils/BindEnterAndSpaceToClick';
import {DefaultProps, PropTypes} from '../../../core/Utils/SitecoreFields';
import QRCode  from 'qrcode.react';

const SocialShare = ({fields, sitecoreContext}) => {

	const socialShare = href => {
		window.open(
			href
				.replace('{fbID}', sitecoreContext.metadata.facebookAppId)
				.replace('{URL}', encodeURIComponent(window.location.href))
				.replace('{TITLE}', encodeURIComponent(getMetaContentByName('title') || getMetaContentByName('Title') || document.title))
				.replace('{IMG}', encodeURIComponent((document.images.imgLb||document.images[0] || 0).src || ''))
				.replace('{WEIBOKEY}', encodeURIComponent(sitecoreContext.metadata.weiboKey)),
			'social share',
			'width=600, height=350',
		);
	}
	const windowGlobalurl = typeof window !== 'undefined' && window.location.href;



	const getMetaContentByName = name => {
		return (document.getElementsByName(name)[0] || 0).content;
	}
	const shareLinks = fields.shareLinks.map(({fields, id}) => {
		return (
			<li key={id} className={fields.IsQRCode.value!==true?fields.title.value:"Wechat"}>
				<span
					role="button"
					tabIndex="0"
					aria-label={fields.title.value}
					onClick={fields.IsQRCode.value!==true?() =>{ socialShare(fields.link.value.href)}:''}
					onKeyUp={BindEnterAndSpaceToClick}
				>
					<Image field={fields.image} />
				</span>
				{fields.IsQRCode.value===true?(
					<div className="wechat-qrcode">
						<h6>{fields.intro.value}</h6>

						<QRCode
							value={windowGlobalurl}
							size={100}
							fgColor="#000000"
						/>
					</div>
					): ("")}

			</li>
		);
	});

	return (
		<div className="social-share">
			<ul>{shareLinks}</ul>
		</div>
	);
};

SocialShare.propTypes = PropTypes.SitecoreItem.inject({
	shareLInks: PropTypes.Multilist.inject(PropTypes.ImageLink),
});

SocialShare.defaultProps = DefaultProps.SitecoreItem.inject({
	shareLinks: DefaultProps.Multilist,
});

export default withSitecoreContext()(SocialShare);
